import { useState } from 'react';
import { format } from 'date-fns';
import { addDays } from 'date-fns';
import { Button, ClickAwayListener } from '@mui/material';
import { FormattedMessage } from 'react-intl';
import 'react-date-range/dist/styles.css';
import 'react-date-range/dist/theme/default.css';

import Header from '../../../components/Header';
import Nav from '../../../components/Nav';
import { Body, PageContainer } from '../../../components/Layout';
import { getInNewWindow } from '../../../modules/fetch';

import {
  ContentColumn,
  Container,
  Heading,
  Title,
  Copy,
  DateContainer,
  DateInput,
  StyledCalendarTodayIcon,
  StyledDateRange,
  Actions,
} from './styles';

const ReviewsReports = () => {
  const [showCalendarReview, setShowCalendarReview] = useState(false);
  const [showCalendarReviewTicket, setShowCalendarReviewTicket] = useState(false);

  const [dateReview, setDateReview] = useState([
    {
      startDate: addDays(new Date(), -6),
      endDate: new Date(),
      key: 'selection',
    },
  ]);

  const [dateReviewTicket, setDateReviewTicket] = useState([
    {
      startDate: addDays(new Date(), -6),
      endDate: new Date(),
      key: 'selection',
    },
  ]);

  const handleDateRangeReview = (range: any) => {
    setDateReview([range.selection]);
    if (range.selection.startDate !== range.selection.endDate) {
      setShowCalendarReview(false);
    }
  };

  const handleDateRangeReviewTicket = (range: any) => {
    setDateReviewTicket([range.selection]);
    if (range.selection.startDate !== range.selection.endDate) {
      setShowCalendarReviewTicket(false);
    }
  };

  const handleDateReviewClickAway = () => {
    setShowCalendarReview(false);
  };

  const handleDateReviewTicketClickAway = () => {
    setShowCalendarReviewTicket(false);
  };

  const buildDateRangeQuery = (startDate: Date, endDate: Date): string => {
    const start = format(startDate, 'yyyy-MM-dd');
    const end = format(endDate, 'yyyy-MM-dd');
    const params = new URLSearchParams({
      startDate: `${start} 00:00:00`,
      endDate: `${end} 23:59:59`,
    });
    return params.toString();
  };

  const handleGenerateReview = () => {
    getInNewWindow(
      '/reviews/report/export',
      buildDateRangeQuery(dateReview[0].startDate as Date, dateReview[0].endDate as Date),
    );
  };

  const handleGenerateReviewTicket = () => {
    getInNewWindow(
      '/review-tickets/report/export',
      buildDateRangeQuery(
        dateReviewTicket[0].startDate as Date,
        dateReviewTicket[0].endDate as Date,
      ),
    );
  };

  return (
    <>
      <Header />
      <PageContainer>
        <Nav currentStep="reviews" subStep={'reports'} />
        <Body>
          <ContentColumn>
            <Container>
              <Heading>
                <Title>
                  <FormattedMessage
                    id="reports.title.review_reports"
                    defaultMessage="Review Reports"
                  />
                </Title>
              </Heading>
              <Actions>
                <Copy>
                  <FormattedMessage
                    id="reports.title.text.review_reports_actions"
                    defaultMessage="Please select the date range to generate the review report"
                  />
                </Copy>
                <ClickAwayListener onClickAway={handleDateReviewClickAway}>
                  <DateContainer>
                    <DateInput onClick={() => setShowCalendarReview(!showCalendarReview)}>
                      <StyledCalendarTodayIcon />
                      {format(dateReview[0].startDate as Date, 'd MMMM y')} -{' '}
                      {format(dateReview[0].endDate as Date, 'd MMMM y')}
                    </DateInput>
                    {showCalendarReview && (
                      <StyledDateRange
                        editableDateInputs={true}
                        onChange={handleDateRangeReview}
                        moveRangeOnFirstSelection={false}
                        ranges={dateReview}
                        showDateDisplay={false}
                      />
                    )}
                  </DateContainer>
                </ClickAwayListener>
                <Button variant="contained" color="primary" onClick={handleGenerateReview}>
                  <FormattedMessage id="reports.actions.button" defaultMessage="Generate" />
                </Button>
              </Actions>
            </Container>
            <Container>
              <Heading>
                <Title>
                  <FormattedMessage
                    id="reports.title.review_ticket_reports"
                    defaultMessage="Review Ticket Reports"
                  />
                </Title>
              </Heading>
              <Actions>
                <Copy>
                  <FormattedMessage
                    id="reports.title.text.review_ticket_reports_actions"
                    defaultMessage="Please select the date range to generate the review ticket report"
                  />
                </Copy>
                <ClickAwayListener onClickAway={handleDateReviewTicketClickAway}>
                  <DateContainer>
                    <DateInput
                      onClick={() => setShowCalendarReviewTicket(!showCalendarReviewTicket)}
                    >
                      <StyledCalendarTodayIcon />
                      {format(dateReviewTicket[0].startDate as Date, 'd MMMM y')} -{' '}
                      {format(dateReviewTicket[0].endDate as Date, 'd MMMM y')}
                    </DateInput>
                    {showCalendarReviewTicket && (
                      <StyledDateRange
                        editableDateInputs={true}
                        onChange={handleDateRangeReviewTicket}
                        moveRangeOnFirstSelection={false}
                        ranges={dateReviewTicket}
                        showDateDisplay={false}
                      />
                    )}
                  </DateContainer>
                </ClickAwayListener>
                <Button variant="contained" color="primary" onClick={handleGenerateReviewTicket}>
                  <FormattedMessage id="reports.actions.button" defaultMessage="Generate" />
                </Button>
              </Actions>
            </Container>
          </ContentColumn>
        </Body>
      </PageContainer>
    </>
  );
};

export default ReviewsReports;
